/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Pearl_Seal_PaceInputs */

const en_kind_pearl_seal_pace = /** @type {(inputs: Kind_Pearl_Seal_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics (new)`)
};

const de_kind_pearl_seal_pace = /** @type {(inputs: Kind_Pearl_Seal_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics (neu)`)
};

/**
* | output |
* | --- |
* | "Analytics (new)" |
*
* @param {Kind_Pearl_Seal_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_pearl_seal_pace = /** @type {((inputs?: Kind_Pearl_Seal_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Pearl_Seal_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_pearl_seal_pace(inputs)
	return de_kind_pearl_seal_pace(inputs)
});